import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchMaintenance} from "./settings/SettingsActions";
import {AppState} from "./RootReducer";
import {MaintenanceWindow} from "./http/protocol";
import {formatDate, fromNow, hasPassed} from "./utils/date";
import "./Maintenance.scss"
import {getDateAsNumber} from "./user/ui/utils";
import {t} from "./i18n";

export const BottomNotification = (props : { text : string }) => {
    const [show,setShow] = useState(true);

    return (
        <div onClick={()=> setShow(!show)} className={"bottom-notification "  + (show ? "" : "hide")}>
           <div className={"content"}>
               <span className={"text"}>{props.text}</span>
           </div>
           <div className={"close-container"}>
               <span className={"material-icons"}>close</span>
           </div>
        </div>
    )
}

export const isAnnounced = (mw : MaintenanceWindow, serverTimeOffset? : number) => {

    let now = Date.now() - (serverTimeOffset ?? 0);
    let announceTime = getDateAsNumber(mw?.announceBeforeStart);
    if(announceTime) {
        return now > announceTime;
    }
    return false;
}
export const hasStarted = (mw : MaintenanceWindow, serverTimeOffset? : number) => {

    let now = Date.now() - (serverTimeOffset ?? 0);
    let startTime = getDateAsNumber(mw?.start);
    if(startTime) {
        return now > startTime;
    }
    return false;
}
export const Maintenance = () => {

    const dispatch = useDispatch();
    let maintenanceWindow = useSelector((app : AppState) => app.settings.maintenance);
    let serverTimeOffset = useSelector((app : AppState) => app.settings.serverTimeOffset);
    useEffect(() => {
        dispatch(fetchMaintenance() as any);
        const interval = setInterval(() => {
            dispatch(fetchMaintenance() as any);
        },5*60*1000)
        return () => {
            clearInterval(interval);
        }
    },[])

    if(maintenanceWindow?.maintenanceWindow && maintenanceWindow.maintenanceWindow.enabled && isAnnounced(maintenanceWindow.maintenanceWindow, serverTimeOffset)) {
        let start = maintenanceWindow.maintenanceWindow.start;
        let text = !hasPassed(start)  ? t("maintenance.starts") : t("maintenance.started");
        return (
            <BottomNotification text={text +  " " + fromNow(maintenanceWindow.maintenanceWindow?.start) + " (" + formatDate(maintenanceWindow.maintenanceWindow?.start)+ ")"}/>
        )
    } else if(maintenanceWindow) {
        const mw = maintenanceWindow?.productMaintenance?.find(mw => mw.enabled && isAnnounced(mw, serverTimeOffset) && !hasStarted(mw, serverTimeOffset))
        if(mw) {
            const time =  fromNow(mw?.start) + " (" + formatDate(mw?.start)+ ")";
            return (
                <BottomNotification text={t("maintenance."+mw.category+".announcement", { start : time})}/>
            )
        }

    }
    return <></>
}